<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!-- begin: Single Modal -->
    <router-view />
    <!-- end: Single Modal -->

    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label>ประเภทการเคลม:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control'"
                  :id="'abcClaimTypeCode'"
                  :name="'abcClaimTypeCode'"
                  v-model="abcClaimTypeCode"
                  :select2-options="abcClaimTypeCodeOptions"
                  ref="abcClaimTypeCodeSelect2"
                  disabled
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div
                class="form-group"
                v-show="abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'"
              >
                <label>ตัวแทนจำหน่าย:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'abcAgentCode'"
                  :name="'abcAgentCode'"
                  :select2-options="abcAgentCodeOptions"
                  v-model="abcAgentCode"
                  ref="abcAgentCodeSelect2"
                  disabled
                ></select2>
                <span class="form-text"></span>
              </div>

              <div
                class="form-group"
                v-show="abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'"
              >
                <label>ร้านค้า:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'abcShopCode'"
                  :name="'abcShopCode'"
                  :select2-options="abcShopCodeOptions"
                  v-model="abcShopCode"
                  ref="abcShopCodeSelect2"
                  disabled
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">อำเภอ:</label>
                <input
                  id="abcAmpher"
                  name="abcAmpher"
                  v-model="abcAmpher"
                  type="text"
                  maxlength="450"
                  class="form-control"
                  placeholder="อำเภอ"
                  disabled
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">จังหวัด:</label>
                <input
                  id="abcProvince"
                  name="abcProvince"
                  v-model="abcProvince"
                  type="text"
                  maxlength="450"
                  class="form-control"
                  placeholder="จังหวัด"
                  disabled
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">เบอร์โทร:</label>
                <input
                  id="abcPhone"
                  name="abcPhone"
                  v-model="abcPhone"
                  type="text"
                  maxlength="450"
                  class="form-control"
                  placeholder="เบอร์โทร"
                  disabled
                />
              </div>
            </div>
          </div>

          <div
            class="kt-section kt-section--first"
            v-show="
              abcClaimTypeCode != null &&
                (abcAgentCode != null || abcShopCode != null)
            "
          >
            <h3 class="kt-section__title">รายการสินค้าเคลม:</h3>
            <div class="kt-section__body">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" width="5%">ลำดับ</th>
                        <th class="text-center" width="15%">แบรนด์สินค้า</th>
                        <th class="text-center" width="15%">ชื่อสินค้า</th>
                        <th class="text-center" width="10%">BARCODE</th>
                        <th class="text-center" width="10%">รหัสทรัพย์สิน(เบียร์สด)</th>
                        <th class="text-center" width="10%">ปัญหาที่พบ</th>
                        <th class="text-center" width="10%">สถานะการเคลม</th>
                        <th class="text-center" width="10%" v-if="this.$root.canShow(['ADMIN_BEER_CLAIM']) && this.isApprove">
                          จำนวนเงิน
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-if="
                          abcClaimItems == null || abcClaimItems.length == 0
                        "
                      >
                        <td colspan="9" class="text-muted text-center">
                          คลิก + เพื่อเพิ่มรายการใหม่
                        </td>
                      </tr>
                      <template v-for="(item, i) in abcClaimItems">
                        <tr>
                          <td class="text-center align-middle">{{ i + 1 }}</td>
                          <td class="text-center align-middle">{{ item.productBrand }}</td>
                          <td class="text-center align-middle">{{ item.material }}</td>
                          <td class="text-center align-middle">{{ item.barcodeOld }}</td>
                          <td class="text-center align-middle">{{ item.depCode }}</td>
                          <td class="text-center align-middle">{{ item.problemType }}</td>
                          <td
                            v-if="
                              item.claimStatusCode ==
                                'CLAIM_STATUS_CONCLUDE_APPROVE'
                            "
                            class="text-center align-middle"
                            style="color:Green"
                          >
                            {{ item.claimStatusName }}
                          </td>
                          <td
                            v-else-if="
                              item.claimStatusCode == 'CLAIM_STATUS_REVOKE'
                            "
                            class="text-center"
                            style="color:Red"
                          >
                            {{ item.claimStatusName }}
                          </td>
                          <td
                            v-else-if="
                              item.claimStatusCode ==
                                'CLAIM_STATUS_CONCLUDE_REJECT'
                            "
                            class="text-center"
                            style="color:Red"
                          >
                            {{ item.claimStatusName }}
                          </td>
                          <td v-else></td>
                          <td
                            v-if="item.isBeerclaimAdmin &&
                              item.claimStatusCode == 'CLAIM_STATUS_CONCLUDE_APPROVE'
                            "
                          >
                            <currency-input
                              class="form-control required"
                              v-model="item.claimPrice"
                              :id="'claimPrice' + i"
                              :name="'claimPrice' + i"
                              v-currency="{ locale, currency }"
                              auto-decimal-mode:true
                              placeholder="จำนวนเงิน"
                              data-msg-required="กรุณากรอกจำนวนเงิน"
                            />
                            <span class="form-text"></span>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button type="button" class="btn btn-secondary" @click="$router.go(-1)">
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary" v-if="this.$root.canShow(['ADMIN_BEER_CLAIM']) && this.isApprove">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../Shared/Select2";
import datepicker from "../../Shared/Datepicker";
import Vue from "vue";
import VueCurrencyInput from "vue-currency-input";
Vue.use(VueCurrencyInput);

export default {
  components: {
    select2,
    datepicker,
  },
  data: function() {
    var self = this;
    return {
      isBeerclaimAdmin: false,
      isApprove: false,
      locale: "th",
      currency: "THB",
      picked: "two",
      abcClaimTypeCode: null,
      abcAgentCode: null,
      abcShopCode: null,
      abcAmpher: null,
      abcProvince: null,
      abcPhone: null,
      abcClaimItems: [],
      index: 0,
      abcClaimTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "BEER_CLAIM_TYPE",
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      abcAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2AgentData",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      abcShopCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopData",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formSubmit: function(e) {
      let self = this;
      var cItems = [];
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }
      self.abcClaimItems.forEach((element) => {
        cItems.push({
          ClaimItemId: element.claimItemId,
          ClaimPrice: element.claimPrice,
          CheckClaimPriceOnly: true,
        });
      });
      Swal.fire({
        title: "บันทึกข้อมูลจำนวนเงิน",
        type: "warning",
        html: "กรุณายืนยันเพื่อบันทึกข้อมูลจำนวนเงิน <strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูลจำนวนเงิน กรุณารอสักครู่...",
          });
          let router = this.$router;
          axios
            .post("/Api/BeerClaim/Conclude", {
              BeerClaimItems: cItems,
              ClaimId: this.$route.params.id,
            })
            .then(function(response) {
              if (response.data.status) {
                KTApp.unblockPage();
                Swal.fire("สำเร็จ", response.data.message, "success").then(
                  function() {
                    router.go(-1), self.$parent.reloadDataTable(false);
                  }
                );
              } else {
                //console.log(response);
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              //console.log(error);
              Swal.fire("เกิดข้อผิดพลาด", error.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;

    if(this.$root.canShow(['super_admin']) == true){
      self.isBeerclaimAdmin = true;
    }else{
      if(typeof this.$root.user.profile.role == "object"){
        const resultAdmin = this.$root.user.profile.role.filter(word => word == "ADMIN_BEER_CLAIM");
        if(resultAdmin.length > 0){
          self.isBeerclaimAdmin = true;
        }else{
          self.isBeerclaimAdmin = false;
        }
      }else if(typeof this.$root.user.profile.role == "string"){
        if(this.$root.user.profile.role == "ADMIN_BEER_CLAIM"){
          self.isBeerclaimAdmin = true;
        }else{
          self.isBeerclaimAdmin = false;
        }
      }else{
        self.isBeerclaimAdmin = false;
      }
    }
    $("#myCheck").click(function(e) {
      $(this)
        .closest("table")
        .find("td input:checkbox")
        .prop("checked", this.checked);
    });

    axios
      .get("/Api/BeerClaim/" + this.$route.params.id)
      .then(function(response) {
        //console.log(response);
        if (response.status == 200) {
          setTimeout(function() {
            if (response.data.claimTypeCode) {
              self.$refs.abcClaimTypeCodeSelect2.setSelectedData({
                id: response.data.claimTypeCode,
                text: response.data.claimTypeName,
              });
            }
          }, 100);

          setTimeout(function() {
            if (response.data.claimAgentCode) {
              self.$refs.abcAgentCodeSelect2.setSelectedData({
                id: response.data.claimAgentCode,
                text: response.data.claimAgentName,
              });
            }
            self.abcAmpher = response.data.ampherName;
            self.abcProvince = response.data.provinceName;
            self.abcPhone = response.data.tel;
          }, 100);

          setTimeout(function() {
            if (response.data.claimShopCode) {
              self.$refs.abcShopCodeSelect2.setSelectedData({
                id: response.data.claimShopCode,
                text: response.data.claimShopName,
              });
            }
            self.abcAmpher = response.data.ampherName;
            self.abcProvince = response.data.provinceName;
            self.abcPhone = response.data.tel;
          }, 100);

          //#region :: set beerClaimItems
          setTimeout(function() {
            if (response.data.beerClaimItems) {
              response.data.beerClaimItems.forEach((b) => {
                //console.log("b ", b);
                if(b.claimStatusCode == "CLAIM_STATUS_CONCLUDE_APPROVE"){
                  self.isApprove = true;
                }
                self.abcClaimItems.push({
                  isBeerclaimAdmin: self.isBeerclaimAdmin,
                  claimPrice: b.claimPrice,
                  productBrandId: b.productBrandId,
                  productBrand: b.productBrandName,
                  materialCode: b.materialCode,
                  material: b.materialName,
                  barcode: b.barcodeNumber,
                  barcodeOld: b.barcodeNumberOld,
                  depCode: b.departmentMaterialCode,
                  manufacturingDate: b.manufacturingDateFormat
                    ? moment(b.manufacturingDateFormat, "DD/MM/YYYY")
                    : null,
                  weight: b.weight,
                  problemTypeCode: b.problemTypeCode,
                  problemType: b.problemTypeName,
                  problemDesc: b.problemDesc,
                  machineTypeCode: b.machineTypeCode,
                  machineType: b.machineTypeName,
                  machineBarcode: b.machineBarcodeNumber,
                  machineCategory: b.machineCategory,
                  pressure: b.pressure,
                  temperature: b.temperature,
                  pmDate: b.pmDateFormat ? moment(b.pmDateFormat) : null,
                  jumpDate: b.jumpDateFormat ? moment(b.jumpDateFormat) : null,
                  standardInstallCode: b.standardInstallCode,
                  standardInstall: b.standardInstallName,
                  claimStatusCode: b.claimStatusCode,
                  claimStatusName: b.claimStatusName,
                  claimItemId: b.claimItemId,
                  agentReceivedDate: b.agentReceivedDateFormat
                    ? moment(b.agentReceivedDateFormat, "DD/MM/YYYY")
                    : null,
                  shopReceivedDate: b.shopReceivedDateFormat
                    ? moment(b.shopReceivedDateFormat, "DD/MM/YYYY")
                    : null,
                  invoice: b.invoice,
                  IsSelectApprove: false,
                });
                self.index += 1;
              });
              //console.log("list edit ", self.abcClaimItems);
            }
          }, 100);
          //#endregion :: set beerClaimItems
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลเบียร์เคลมที่คุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลเบียร์เคลมได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/BeerClaim/ResultBeerClaim.vue